var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"width":"84%","height":"17rem"}})}
var staticRenderFns = []

export { render, staticRenderFns }